import { runDemo } from "../shared/demoRunner";
import { createSPSTestScene } from "./scene";

runDemo({ createScene: createSPSTestScene });
